import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_523b782c: FaireBrandEntity = {
  token: "b_523b782c",
  type: "brand",
  name: "Alphabet Studios",
  avatarUrl:
    "https://cdn.faire.com/fastly/fde952fc92825cb595c8e841c5960133e66a0d1c25c647a1cfbe3b95eb71b2e7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f7e152f279e14c679f10cef9df5964c3e8ed04db874313f58c61d63a4333ed47.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fde952fc92825cb595c8e841c5960133e66a0d1c25c647a1cfbe3b95eb71b2e7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f7e152f279e14c679f10cef9df5964c3e8ed04db874313f58c61d63a4333ed47.jpeg",
  location: "Bellingham, WA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 59,
  isTopShop: true,
  isInsider: true,
  description:
    "Jesse Levison was born and raised in Miami, Florida and has been a printmaker for over thirteen years. Her cards, jewelry, prints, and books render archetypal forms through vibrant, playful design and bring a renewed sense of wonder and recognition to the everyday. \n\nThe story of Alphabet Studios began fifteen years ago while Jesse was living in Brooklyn, New York. She started printing on her kitchen table and created Gold Teeth Brooklyn—a stationery and greeting card company centered around thoughtful palettes and small batch runs printed on handmade cotton rag paper. Her designs incorporate the bold colors and tropical landscapes of her origins in south Florida, as well as the iconic Americana of Brooklyn winters. Gold Teeth moved around a bit in the following years, operating out of Brooklyn for nine years and then Los Angeles for a further six. In the summer of 2021, Jesse and her family relocated to Bellingham, Washington where they intend to stay and put down roots. \n\nAlphabet Studios is the new name of Gold Teeth Brooklyn as of April 2023! Jesse felt it was time for a name change to better represent her company’s growth and status as a globally stocked brand. Her sunny studio in downtown Bellingham houses a production crew of three and a shop dog, Scout. Alphabet Studios represents her intention to stay playful and rooted in the simple designs that bring joy to everyday life. \n\nContact: [redacted-email]",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:59.526Z",
    importedBy: "entity-db-cli",
  },
};
